import { render, staticRenderFns } from "./widgetThreshold.vue?vue&type=template&id=16b2c896&scoped=true"
import script from "./widgetThreshold.vue?vue&type=script&lang=js"
export * from "./widgetThreshold.vue?vue&type=script&lang=js"
import style0 from "./widgetThreshold.vue?vue&type=style&index=0&id=16b2c896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2c896",
  null
  
)

export default component.exports